import styled from 'styled-components'
import { PaddingContainer, GridMixin, FadeUpMixin } from 'components/common/common_styles'
import TitleColumn from 'components/common/titleColumn'
import { StyledP } from 'components/common/typography'
import { sizeMobile, sizeMedium, gutter } from 'components/globalStyles'

const transitionTime = '1.5s'

export const MainContainer = styled(PaddingContainer)`
  ${GridMixin};
  grid-template-columns: minmax(auto, 1fr) auto auto auto;
  grid-template-rows: auto 1fr;
  grid-auto-flow: column;
  column-gap: 16px;
  row-gap: 8px;

  @media (max-width: ${sizeMedium}) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, auto);
    padding-right: ${gutter};
  }

  @media (max-width: ${sizeMobile}) {
    display: block;
    padding-right: 0;
  }
`

export const TextOuterWrapper = styled.div`
  grid-row: 1 / span 2;
  padding-right: 32px;

  @media (max-width: ${sizeMedium}) {
    grid-row: 1;
    grid-column: 1 / span 3;
    padding-bottom: 48px;
    padding-right: 0;
  }

  @media (max-width: ${sizeMobile}) {
    padding-left: ${gutter};
    padding-right: ${gutter};
  }
`

export const TextContainer = styled(TitleColumn)`
  color: ${props => (props.black ? 'white' : 'var(--spBlack)')};
  transition: color ${transitionTime};

  & h2,
  & a {
    color: ${props => (props.black ? 'white' : 'var(--spBlack)')};
    transition: color ${transitionTime};
  }

  & button {
    border-color: ${props => (props.black ? 'white' : 'var(--spBlack)')};
    transition: color ${transitionTime};
  }
`

export const ImageWrapper = styled.div`
  ${FadeUpMixin({ delay: props => props.offset * 0.25 })};
`

export const ImageCaption = styled.div`
  position: relative;
  ${FadeUpMixin({ delay: props => props.offset * 0.25 })};

  & h2 {
    color: ${props => (props.black ? 'white' : 'var(--gray1)')};
    opacity: 0.2;
  }

  & h4 {
    color: ${props => (props.black ? 'white' : 'var(--spBlack)')};
    position: absolute;
    top: 0.95em;
    left: 1em;
    width: max-content;
  }
`

export const ImageCaptionNumber = styled(StyledP)`
  color: ${props => (props.black ? 'white' : 'var(--gray1)')} !important;
  opacity: 0.2;
`

export const ImageCaptionText = styled(StyledP)`
  color: ${props => (props.black ? 'white' : 'var(--spBlack)')};
  position: absolute;
  top: 0.95em;
  left: 1em;
  width: max-content;
`